<template>
  <div class="activity-score-entry-table">
    <el-table :data="practiceRecordList" style="width: 100%">
      <el-table-column prop="className" label="班级" width="180">
        <template slot-scope="scope">
          {{ scope.row.gradeName + scope.row.className }}
        </template>
      </el-table-column>
      <el-table-column prop="studentName" label="姓名" width="180">
      </el-table-column>
      <el-table-column prop="studentNumber" label="学号" width="180">
      </el-table-column>
      <el-table-column prop="hours" label="学时" width="180"> </el-table-column>
      <el-table-column prop="credit" label="学分" width="180">
      </el-table-column>
      <el-table-column prop="evaluationLevel" label="评定等级">
      </el-table-column>
      <el-table-column label="修改" width="120px">
        <template slot-scope="scope">
          <div class="handle-container">
            <!-- 修改 -->
            <el-button
              type="warning"
              icon="el-icon-edit"
              @click="editClick(scope.row)"
              v-hasPermi="'sc:practicerecord:update'"
              size="small"
            >修改
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: ["practiceRecordList"],
  data() {
    return {};
  },
  methods: {
    editClick(item) {
      let data = JSON.parse(JSON.stringify(item));
      this.$emit("editClick", data);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./activityScoreEntryTable.scss";
</style>